import OpenSans from '../fonts/OpenSansRegular.woff';
import SegoeUI from '../fonts/SegoeUI.woff';
import Poppins from '../fonts/PoppinsRegular.woff';

export const FONT_DEFAULT = 'Open Sans';

export const styleIdFontSetting = 'font-faces-setting';

export const FONT_FACES_DEFAULT = `
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(${OpenSans}) format('woff');
} 
@font-face {
  font-family: 'Segoe UI';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(${SegoeUI}) format('woff');
} 
@font-face {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(${Poppins}) format('woff');
} 
`;

/**
 * Injects a style tag in <head> element of the document with given id
 *
 * @param {string} cssString - CSS string with font faces you want the browser to load
 * @param {string} styleId - Id of the style tag to be injected into the document
 */
export const loadFonts = (cssString: string, styleId: string): void => {
  if (!document.getElementById(`#${styleId}`)) {
    const head = document.getElementsByTagName('head')[0];
    const style = document.createElement('style');
    style.innerHTML = cssString;
    style.id = `#${styleId}`;
    head.appendChild(style);
  }
};
